
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import PinnedItemsModule from '@/store/modules/pinned-items';

interface PinnedItem {
  id: string;
  title: string;
  link: string;
  icon?: string;
  section: string;
  sectionTitle: string;
  groupTitle?: string;
  timestamp: number;
}

@Component
export default class PinnedSection extends Vue {
  @Prop({ required: true })
  public storeId!: number;
  
  @Prop({ default: false })
  public mini!: boolean;
  
  public expanded: boolean = true;
  private pinnedItemsStore = PinnedItemsModule;
  
  get pinnedItems(): PinnedItem[] {
    return this.pinnedItemsStore.getPinnedItems;
  }
  
  // Watch for changes to expanded state and save to localStorage
  @Watch('expanded')
  private onExpandedChanged(newVal: boolean): void {
    localStorage.setItem(`pinned_section_expanded_${this.storeId}`, String(newVal));
  }
  
  // Watch for changes to pinned items and expand when items are added
  @Watch('pinnedItems')
  private onPinnedItemsChanged(newItems: PinnedItem[], oldItems: PinnedItem[]): void {
    // If items were added (count increased), expand the section
    if (oldItems && newItems.length > oldItems.length) {
      this.expanded = true;
    }
  }
  
  private handleItemClick(item: PinnedItem): void {
    this.$emit('item-clicked', item);
  }
  
  private async handleUnpin(item: PinnedItem): Promise<void> {
    await this.pinnedItemsStore.unpinItem({
      itemId: item.id,
      storeId: this.storeId
    });
    
    // Optional: Show feedback
    this.$emit('item-unpinned', item);
  }
  
  created(): void {
    // Load expanded state
    const savedState = localStorage.getItem(`pinned_section_expanded_${this.storeId}`);
    if (savedState !== null) {
      this.expanded = savedState === 'true';
    } else {
      // Default to expanded when first shown with items
      this.expanded = true;
      localStorage.setItem(`pinned_section_expanded_${this.storeId}`, 'true');
    }
  }
}
